/**
 * Every API error has the shape { error: { code, message } }.
 * The client maps `code` to a translated message; `message` is an English fallback.
 */
export const ERROR_CODES = [
  'BAD_REQUEST',
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'EMAIL_NOT_VERIFIED',
  'FORBIDDEN',
  'ADMIN_2FA_REQUIRED',
  'ADMIN_REAUTH',
  'SIGNUPS_CLOSED',
  'BANNED',
  'NOT_FOUND',
  'CONFLICT',
  'RATE_LIMITED',
  'UNDERAGE',
  'PAYLOAD_TOO_LARGE',
  'UNSUPPORTED_MEDIA_TYPE',
  'INVALID_LINK',
  'NOT_A_TRACK',
  'TRACK_NOT_FOUND',
  'UPSTREAM_BUSY',
  'UPSTREAM_ERROR',
  'INTERNAL',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export interface ApiErrorBody {
  error: {
    code: ErrorCode;
    message: string;
    /** Optional field-level details for validation errors. */
    details?: Record<string, string[]>;
  };
}

export function isApiErrorBody(value: unknown): value is ApiErrorBody {
  if (typeof value !== 'object' || value === null) return false;
  const error = (value as { error?: unknown }).error;
  return (
    typeof error === 'object' &&
    error !== null &&
    typeof (error as { code?: unknown }).code === 'string' &&
    typeof (error as { message?: unknown }).message === 'string'
  );
}
